import React from 'react';

import {HashRouter, Routes, Route} from 'react-router-dom'
import Canvas from './components/canvas.component';
import Ingreso from './components/ingreso.component';

import { SHOWROOM_ROUTE, PARTICULARES_ROUTE, COMERCIALES_ROUTE } from './config/routes'


function App() {
  return (
    <HashRouter>
      <div className='main-showroom-page'>
        <Routes>
          <Route path={SHOWROOM_ROUTE} element={<Ingreso/>}/>
          <Route 
            path={PARTICULARES_ROUTE+"/"} 
            element={
              <Canvas
                isComerciales = {false}
              />}
          />
          <Route 
            path={COMERCIALES_ROUTE+"/"} 
            element={
              <Canvas
                isComerciales = {true}
              />
            }
          />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
